export function parseStyles(html) {
  const styleRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
  const styleContents = [];
  let match;
  while ((match = styleRegex.exec(html)) !== null) {
    const content = match[1].trim();
    if (content) styleContents.push(content);
  }
  return styleContents;
}
